window.all_free_straps = [];
class ShoppableModal extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    

    this._state = {
      products: [],
      revealedIds: new Set(),
      activeId: null,
      isDetailViewOpen: false,
      isOpen: false,
      selectedProduct: null
    };
    this._videoSrc = "";
    this._hls = null;

    this._upsellState = {
      data: null,
      bundleId: null,
      selectedStraps: [],
      selectedPurse: null,
      step: 1
    };
  }

  connectedCallback() {
    const startAttr = this.getAttribute('data-start');
  
    // If the attribute is "2026-04-28T13:21:00", we append the UK offset.
    // For British Summer Time (BST), use +01:00. For GMT, use +00:00.
    // A more robust way is to ensure the attribute itself ends in +01:00 or Z.
    
    // connectedCallback
    if (this.hasAttribute('data-testing')) {
      this.startTime = Date.now() + 15000;
    } else if (startAttr.includes('Z') || startAttr.includes('+')) {
      this.startTime = new Date(startAttr).getTime();
    } else {
      this.startTime = new Date(startAttr + "+01:00").getTime();
    }

    this.customDuration = parseInt(this.getAttribute('data-video-duration'), 10) / 1000;
  }
  
  initCountdown() {
    const video = this.shadowRoot.getElementById('main-video');
    const timerEl = this.shadowRoot.getElementById('countdown-timer');
    const overlay = this.shadowRoot.querySelector('.countdown-overlay');

    if (!timerEl || !overlay) return; // ✅ prevents crash

    const startAttr = this.getAttribute('data-start');
    // Sync logic: Force UK offset if not present
    if (this.hasAttribute('data-testing')) {
      this.startTime = Date.now() + 15000;
    } else {
      this.startTime = (startAttr.includes('Z') || startAttr.includes('+'))
        ? new Date(startAttr).getTime()
        : new Date(startAttr + "+01:00").getTime();
    }

    const update = () => {
      const now = Date.now(); // This is always UTC-based internally
      const diff = this.startTime - now;

      if (diff <= 0) {
        overlay.style.display = 'none';
        this.classList.remove('live-waiting');
        if (video) {
          video.muted = false;
          video.play().catch(() => {});
        }

        clearInterval(this._countdownInterval);
        return;
      }

      this.classList.add('live-waiting');
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      timerEl.textContent =
        `${hours.toString().padStart(2, '0')}:` +
        `${minutes.toString().padStart(2, '0')}:` +
        `${seconds.toString().padStart(2, '0')}`;
    };

    update();
    this._countdownInterval = setInterval(update, 1000);
  }

  updateStatusBadge() {
    const badge = this.shadowRoot.getElementById('video-status');
    const text = badge.querySelector('.status-text');
    const now = Date.now();
    
    // Calculate if the current time falls within the "Live" window
    const isLive = now >= this.startTime && now < (this.startTime + (this.customDuration * 1000));

    if (isLive) {
      badge.classList.add('is-live');
      text.textContent = 'Live';
    } else {
      badge.classList.remove('is-live');
      // If it's before start time, you could show "Upcoming", 
      // but per your request, we default to "Recorded"
      text.textContent = 'Recorded';
    }
  }
  getLiveOffset() {
    const now = Date.now();
    const elapsed = (now - this.startTime) / 1000;

    const duration = this.customDuration;

    if (!duration || isNaN(duration)) return 0;

    // If live hasn't started
    if (elapsed <= 0) return 0;

    // If still inside first run of video
    if (elapsed < duration) {
      return elapsed;
    }

    // After duration passes → stay pinned at "live edge"
    return duration - 0.1;
  }
  
  async addToCart(product, bundleId) {
    if (!product || !product.variantID) return;
    const properties = bundleId ? { '_bundle_id': bundleId } : {};

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: product.variantID, 
              quantity: 1,
              properties: properties
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();
      console.log('Added to cart:', data);

      const btn = this.shadowRoot.querySelector('.buy-btn');
      if (btn) {
        const original = btn.textContent;
        btn.textContent = 'ADDED';
        setTimeout(() => {
          btn.textContent = original;
        }, 1200);
      }

    } catch (err) {
      console.error('Add to cart error:', err);
    }
  }

  formatTime(seconds) {
    if (isNaN(seconds) || seconds === null) return "0:00";
    const min = Math.floor(seconds / 60);
    const sec = Math.floor(seconds % 60);
    return `${min}:${sec.toString().padStart(2, '0')}`;
  }

  set products(data) {
    this._state.products = [...data].sort((a, b) => a.timestamp - b.timestamp);
    this.render();
  }

  set videoSources(sources) {
    const video = this.shadowRoot?.getElementById('main-video');
    if (!video) {
      this._videoSrc = sources.mp4 || "";
      this._hlsSrc = sources.hls || "";
      return;
    }

    if (this._hls) {
      this._hls.destroy();
      this._hls = null;
    }

    if (sources.hls) {
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = sources.hls;
      } else if (typeof Hls !== 'undefined' && Hls.isSupported()) {
        this._hls = new Hls({
                      capLevelToPlayerSize: true,
                      startLevel: 0
                    });
        this._hls.loadSource(sources.hls);
        this._hls.attachMedia(video);
      } else {
        video.src = sources.mp4 || "";
      }
    } else {
      video.src = sources.mp4 || "";
    }
  }

  disconnectedCallback() {
    if (this._hls) this._hls.destroy();
  }

  setState(newState) {
    this._state = { ...this._state, ...newState };
    this.syncUI();
  }
  isLiveStarted() {
    return Date.now() >= this.startTime;
  }
  open() {
    console.log(this.customDuration)
    this.setAttribute('open', '');

    this.setState({
      revealedIds: new Set(),
      activeId: null,
      isDetailViewOpen: false,
      isOpen: true
    });

    const video = this.shadowRoot.getElementById('main-video');
    if (!video) return;

    // --- FIX FOR IOS: PRIMING ---
    // We play and immediately pause. Because 'open()' is called by a user click,
    // this "unlocks" the video for the setInterval to play it later.
    video.play().then(() => {
      // video.pause();
    }).catch(e => console.warn("Priming failed:", e));
    // ----------------------------


    const performSync = () => {
      const now = Date.now();
      const elapsedSeconds = (now - this.startTime) / 1000;

      // 1. TOO EARLY: If the scheduled start time is in the future, do not play.
      if (elapsedSeconds < 0) {
        video.pause();
        video.currentTime = 0;
        return;
      }

      // 2. CALCULATE POSITION: Determine where the video should be.
      // If elapsed time is within the video duration, sync to that offset.
      // If the video has already finished (elapsed > duration), start from 0 as a replay.
      const seekTo = (elapsedSeconds < this.customDuration) ? elapsedSeconds : 0;
      console.log(seekTo)
      console.log(elapsedSeconds)
      console.log(this.customDuration)

      try {
        video.currentTime = seekTo;
        video.play().catch((err) => {
          console.warn("Autoplay blocked or interrupted:", err);
        });
      } catch (e) {
        console.warn("Seeking error:", e);
      }
    };

    // Ensure metadata is loaded so currentTime can be set accurately.
    if (video.readyState >= 1) {
      performSync();
    } else {
      video.addEventListener('loadedmetadata', performSync, { once: true });
    }
  }
  close() {
    this.removeAttribute('open');
    const video = this.shadowRoot.getElementById('main-video');
    video.currentTime = 0;
    video.pause();
    this.setState({ isOpen: false, isDetailViewOpen: false });
  }

  syncUI() {
    const modal = this.shadowRoot.querySelector('.modal-overlay');
    const cards = this.shadowRoot.querySelectorAll('.product-card');
    const detailView = this.shadowRoot.getElementById('detail-view');

    modal.style.display = this._state.isOpen ? 'flex' : 'none';

    cards.forEach(card => {
      const id = String(card.dataset.id).trim();

      card.classList.toggle(
        'revealed',
        this._state.revealedIds.has(id)
      );

      card.classList.toggle(
        'active',
        String(this._state.activeId).trim() === id
      );

      if(String(this._state.activeId).trim() === id){
        card.classList.add('showen');

      }
    });

    detailView.classList.toggle('open', this._state.isDetailViewOpen);
    if (this._state.isDetailViewOpen) this.renderDetails();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style> 
        :host {
          --accent: #000;
          --sidebar-width: 400px;
          --transition: opacity .3s linear, max-width .3s linear, border-color .3s linear;
          --color-border: rgba(41, 41, 41, 0.16);
          --colorBtnPrimary: #0c314a;
          --colorBtnPrimaryText: #ffffff;
          --colorBtnPrimaryDim: #082234;
          --color-highlight: rgba(117, 117, 117, 1);
        }

        :host([data-show-active-product-only="true"]) .product-card:not(.active) {
          display: none !important;
        }

        :host([data-show-active-product-only="true"]) h2.hide-mobile {
          display: none !important;
        }

        :host(.live-waiting) .video-wrapper {
          pointer-events: none;
        }

        :host(.live-waiting) .custom-controls {
          display: none;
        }

        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(15px);
          z-index: 9999;
          display: none;
          align-items: center;
          justify-content: center;
        }

        .modal-container {
          display: flex;
          width: 100%;
          height: 100%;
          background: #fff;
          position: relative;
          overflow: hidden;
        }

        .close-modal-btn {
          position: absolute;
          top: 20px;
          left: 20px;
          z-index: 100;
          background: rgba(255, 255, 255, 0.8);
          border: none;
          border-radius: 50%;
          width: 44px;
          height: 44px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }

        /* --- Video Section --- */
        .video-wrapper {
          flex: 1;
          background: #000;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        /* --- Sidebar Section --- */
        .sidebar {
          width: var(--sidebar-width);
          border-left: 1px solid #eee;
          display: flex;
          flex-direction: column;
          position: relative;
          background: #fff;
          z-index: 20;
        }

        .sidebar-header {
          padding: 24px;
          border-bottom: 1px solid #eee;
          font-weight: bold;
          font-size: 1.2rem;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        #product-list {
          flex: 1;
          overflow-y: auto;
          padding: 16px;
          display: flex;
          flex-direction: column;
          flex-direction: column-reverse;
          justify-content: flex-end;
          gap: 12px;
        }

        /* --- Cards --- */
        .product-card {
          display: flex;
          padding: 8px;
          gap: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1.5px solid var(--color-border);
          border-radius: 0px;
          position: relative;
        }

        .product-card.revealed {
          opacity: 0.8;
          filter: grayscale(0.5);
        }

        /* 1. Hide all cards by default */
        #product-list .product-card {
          display: none;
        }

        /* 2. If there is an active card, show all cards */
        #product-list:has(.product-card.active) .product-card {
          display: flex;
        }

        /* 3. Then apply your previous rule (hide after active) */
        #product-list:has(.product-card.active) .product-card.active~.product-card {
          display: none;
        }

        /* 4. Optional: reveal all on hover */
        #product-list:has(.product-card:hover) .product-card {
          display: flex;
        }

        .product-card.active,
        .product-card:hover {
          opacity: 1;
          filter: grayscale(0);
          background: #fcfcfc;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }

        .product-card img {
          width: 112px;
          min-height: 90px;
          object-fit: cover;
          border-radius: 0px;
        }

        .product-card.active img {
          width: 176px;
        }

        .info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 1.3;
    gap: 0.3rem;
        }

        .info h4 {
          margin: 0px;
          font-size: 0.9rem;
        }

        .info p {
          margin: 0;
          color: #888;
          font-size: 0.8rem;
        }

        /* --- Play Trigger --- */
        .play-trigger {
          width: 100%;
          max-width: 32px;
          height: 32px;
          border-radius: 20px;
          border: 1px solid #ddd;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          transition: var(--transition);
          padding: 0;
          position: absolute;
          bottom: 8px;
          right: 8px;
        }

        .link-time {
          max-width: 0;
          opacity: 0;
          font-size: 11px;
          font-weight: bold;
          transition: var(--transition);
          white-space: nowrap;
        }

        .product-card:hover .play-trigger {
          max-width: 80px;
        }

        .product-card.active .play-trigger {
          display: none;
        }

        .product-card.active .link-time,
        .product-card:hover .play-trigger .link-time {
          max-width: 50px;
          opacity: 1;
          margin-left: 6px;
        }

        /* --- Detail View --- */
        .detail-view {
          position: absolute;
          inset: 0;
          background: #fff;
          transform: translateX(100%);
          transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1);
          z-index: 30;
          display: flex;
          flex-direction: column;
        }

        .detail-view.open {
          transform: translateX(0);
        }

        .sticky-back-btn-container {

          position: absolute;
          top: 0;
          left: 0;
          width: 100%;

          padding: 16px;
          box-sizing: border-box;

          background: rgba(255, 255, 255, 0.7);

          backdrop-filter: blur(8px);
          border-bottom: 1px solid hsla(0, 0%, 100%, .12);
        }

        .back-btn {
          border: none;
          background: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 8px;
        }

        .detail-scroll-area {
          flex: 1;
          overflow-y: auto;
          padding: 24px;
          scrollbar-width: none;
          -ms-overflow-style: none;
          padding-top: 70px;
        }

        .buy-btn {
          width: 100%;
          padding: 20px;
          border: none;
          font-weight: bold;
          cursor: pointer;
          transition: opacity 0.2s;
        }

        @keyframes spin {
          0% {
            transform: rotate(0)
          }

          to {
            transform: rotate(360deg)
          }
        }

        .btn {
          background: var(--colorBtnPrimary);
          color: var(--colorBtnPrimaryText);
          position: relative;
          line-height: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .btn--loading {
          background-color: var(--colorBtnPrimaryDim);
          color: var(--colorBtnPrimaryDim);

        }

        .btn--loading:before {
          content: "";
          display: block;
          width: 24px;
          height: 24px;
          position: absolute;
          border-radius: 50%;
          border: 3px solid;
          border-color: #fff;
          border-color: var(--colorBtnPrimaryText);
          border-top-color: transparent;
          animation: spin 1s linear infinite;
        }

        .buy:hover {
          transition: background .2s ease 0s;
        }

        /* --- Custom Video Controls --- */
        .custom-controls {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 30px 20px 20px;
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
          display: flex;
          align-items: center;
          gap: 15px;
          color: white;
        }

        .progress-container {
          flex: 1;
          height: 4px;
          background: rgba(255, 255, 255, 0.2);
          cursor: pointer;
          position: relative;
        }

        .progress-bar {
          height: 100%;
          background: #fff;
          width: 0%;
        }

        /* Hide floating actions on desktop */
        .mobile-floating-actions {
          display: none;
        }

        div#detail-content img {
          width: 100%;
          border-radius: 4px;
          margin-bottom: 0.7rem;
          aspect-ratio: 0.75;
          object-fit: contain;
        }

        /* =========================================
                  NEW MOBILE DESIGN OVERRIDES
                  ========================================= */
        /* =========================================
          NEW MOBILE DESIGN OVERRIDES
          ========================================= */
        @media (max-width: 900px) {
          .hide-mobile {
            display: none !important;
          }

          .modal-container {
            display: block;
          }

          /* Video goes full screen */
          .video-wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            inset: 0;
            z-index: 1;
          }

          video {
            object-fit: cover;
          }

          /* Top Right Close Button */
          .close-modal-btn {
            top: 1rem;
            right: 1rem;
            left: auto;
            background: transparent;
            color: white;
            box-shadow: none;
          }

          .close-modal-btn svg {
            stroke: white;
          }

          /* Sidebar becomes an invisible container for the floating product card */
          .sidebar {
            width: 100%;
            height: auto;
            border: none;
            background: transparent;
            position: absolute;
            bottom: 60px;
            /* Sits right above the progress bar */
            left: 0;
            z-index: 15;
            padding: 0;
            /* Changed to 0 to allow full-width scroll */
            pointer-events: none;
            /* Let touches pass through to video */
            overflow: hidden;
            /* Ensure no vertical spill */
          }

          .sidebar-header {
            display: none;
          }

          #product-list {
            padding: 0 15px;
            /* Padding on sides so the first/last cards don't hit edges */
            pointer-events: auto;
            /* Re-enable clicks on the cards */
            flex-direction: row;
            display: flex;
            /* Ensure flex for horizontal layout */
            overflow-x: auto;
            /* Enable horizontal scrolling */
            scroll-snap-type: x mandatory;
            /* Smooth snapping to cards */
            scrollbar-width: none;
            /* Hide scrollbar for Firefox */
            gap: 12px;
          }

          #product-list::-webkit-scrollbar {
            display: none;
          }

          /* Hide scrollbar for Chrome/Safari */

          /* Hide all products by default on mobile */
          .product-card {
            display: flex;
            background: #fff;
            border-radius: 4px;
            padding: 8px 12px;
            margin: 0;
            /* 88% width makes the card nearly full width, leaving 12% for the next card to show */
            flex: 0 0 88%;
            scroll-snap-align: center;
            /* Snaps card to center of screen */
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            border: none;
            box-sizing: border-box;
          }

          /* ONLY display the active product card */
          .product-card.active {
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .product-card.active img {
            width: 50px;
            min-height: 65px;
            border-radius: 2px;
          }

          .product-card .info h4 {
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 2px;
          }

          .product-card .info p {
            font-size: 11px;
            margin-bottom: 4px;
          }

          .product-card .info strong {
            font-size: 13px;
            font-weight: bold;
          }

          /* Play Trigger turns into the circular button inside the active mobile card */
          .product-card.active .play-trigger {
            // display: flex;
            // position: relative;
            // bottom: auto;
            // right: auto;
            // margin-left: auto; /* Push it to the far right of the card */
            // width: 34px;
            // height: 34px;
            // border: 1px solid #ccc;
          }

          .product-card.active .play-trigger svg {
            fill: black;
            margin-left: 2px;
          }

          .product-card.active .link-time {
            display: none;
          }

          /* Detail View (Drawer) sliding up from the bottom */
          .detail-view {
            position: fixed;
            bottom: 0;
            top: auto;
            left: 0;
            right: 0;
            height: 75vh;
            transform: translateY(100%);
            border-radius: 20px 20px 0 0;
            z-index: 50;
            box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.1);
            pointer-events: auto;
          }

          .detail-view.open {
            transform: translateY(0);
          }

          .sticky-back-btn-container {
            border-radius: 20px 20px 0 0;
          }

          .back-btn svg {
            transform: rotate(-90deg);
          }

          /* Arrow points down to close drawer */

          /* Right-side floating action buttons to match design */
          .mobile-floating-actions {
            display: flex;
            flex-direction: column;
            gap: 16px;
            position: absolute;
            right: 15px;
            bottom: 160px;
            /* Increased to stay above the new horizontal cards */
            z-index: 10;
          }

          .action-btn {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.4);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            backdrop-filter: blur(4px);
            -webkit-backdrop-filter: blur(4px);
            cursor: pointer;
          }

          /* Thinner progress bar for mobile */
          .custom-controls {
            z-index: 10;
            padding: 15px;
            background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
          }

          #time-display {
            display: none;
          }

          .progress-container {
            height: 3px;
          }

          .product-card img {
            width: 65px;
          }
        }

        .selection-indicator::after {
          content: " ";
          border-radius: 50%;
          transform: scale(1);
          box-shadow: 0 0 0 0 var(--color-highlight);
          height: 10px;
          width: 10px;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 var(--color-highlight);
            opacity: .7
          }

          70% {
            transform: scale(1);
            box-shadow: 0 0 0 8px var(--color-highlight);
            opacity: 0
          }

          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 var(--color-highlight);
            opacity: 0
          }
        }

        .selection-indicator-container {
          display: none;
          position: absolute;
          top: 14px;
          right: 14px;
        }

        .product-card.active .selection-indicator-container {
          display: flex;
        }

        .product-card.active .selection-indicator {
          display: flex;
          opacity: 1;
          visibility: visible;
        }

        .selection-indicator {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 10px;
          width: 10px;
          visibility: hidden;
          background: var(--color-highlight);
          border-radius: 50%;
          transform: scale(1);
        }

        /* 1. Hide all H2 elements by default */
        #product-list h2 {
          display: none;
          margin: 0px;
          font-size: 1.2rem;
        }

        /* 2. SHOW CASE A: The H2 immediately after the active card */
        #product-list .product-card.active+h2 {
          display: block;
        }

        /* 3. SHOW CASE B: If NO active card exists in the list, show the first H2 */
        /* Logic: "Select the first H2 ONLY IF #product-list does not contain .active" */
        #product-list:not(:has(.active)) h2:first-of-type {
          display: block;
        }

        /* 4. Formatting Fix: Handle whitespace/text nodes if '+' is too strict */
        #product-list .product-card.active~h2 {
          display: block;
        }

        #product-list .product-card.active~h2~h2 {
          display: none;
        }

        /* Base style for the overlay icon */
        .play-pause-overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(1.5);
          width: 80px;
          height: 80px;
          color: white;
          opacity: 0;
          pointer-events: none;
          /* Important: clicks must go through to the wrapper */
          transition: opacity 0.2s, transform 0.2s;
          z-index: 5;
          filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.3));
        }

        /* When the wrapper has the .is-paused class, show the SVG */
        .video-wrapper.is-paused .play-pause-overlay {
          opacity: 0.8;
          transform: translate(-50%, -50%) scale(1);
        }

        .play-pause-overlay svg {
          width: 100%;
          height: 100%;
        }

        /* Container for the loader */
        .video-loader {
          position: absolute;
          inset: 0;
          display: none;
          /* Hidden by default */
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.2);
          z-index: 6;
        }

        /* Show loader when class is present */
        .video-wrapper.is-loading .video-loader {
          display: flex;
        }

        /* Simple CSS Spinner */
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: #fff;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .video-loader {
          position: absolute;
          inset: 0;
          display: none;
          align-items: center;
          justify-content: center;
          background: #000;
          /* Solid black or very dark at the start */
          z-index: 6;
          transition: opacity 0.5s ease;
        }

        .video-wrapper.is-loading .video-loader {
          display: flex;
        }



        .countdown-overlay {
          position: absolute;
          inset: 0;
          background: #000;
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 10;
          text-align: center;
        }

        .countdown-text {
          font-size: 16px;
          margin-bottom: 10px;
          opacity: 0.8;
        }

        #countdown-timer {
          font-size: 32px;
          font-weight: bold;
        }


        .status-badge {
          display: flex;
          align-items: center;
          gap: 5px;
          background: rgba(0, 0, 0, 0.6);
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
          color: white;
          text-transform: uppercase;
          align-items: center;
          justify-content: center;
          line-height: 1;
          position: absolute;
          right: 1rem;
          top: 1rem;
        }

        @media (max-width: 900px) {
          .status-badge {
            top: 1rem;
            left: 1rem;
            right: auto;
          }
        }

        .status-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #888;
          /* Default gray for recorded */
        }

        .status-badge.is-live .status-dot {
          background: #ff0000;
          box-shadow: 0 0 5px #ff0000;
          animation: blink 1.5s infinite;
        }

        @keyframes blink {
          0% {
            opacity: 1;
          }

          50% {
            opacity: 0.4;
          }

          100% {
            opacity: 1;
          }
        }




        /* Color Swatch Styles */
        .swatch-container {
          margin: 0 0 20px 0;
          width: 100%;
        }

        .swatch-label {
          font-weight: bold;
          margin-bottom: 8px;
          font-size: 14px;
          display: block;
        }

        .swatch-list {
          display: flex;
          flex-wrap: wrap;
          /* This makes them move to the next line if they don't fit */
          gap: 10px;
          /* Space between circles */
          width: 100%;
        }

        .swatch {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: 1px solid #e2e2e2;
          cursor: pointer;
          background-size: cover;
          background-position: center;
          transition: all 0.2s ease;
          box-sizing: border-box;
          flex-shrink: 0;
          /* Prevents them from squishing into ovals */
        }

        .swatch:hover {
          // transform: scale(1.1);
        }

        .swatch.active {
          border: 1px solid transparent;
          box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        }

        /* Tooltip for color name on hover */
        .swatch::after {
          content: attr(data-name);
          position: absolute;
          bottom: 120%;
          left: 50%;
          transform: translateX(-50%);
          background: #333;
          color: #fff;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 10px;
          white-space: nowrap;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.2s;
        }

        .swatch:hover::after {
          // opacity: 1;
        }

       .product-card .swatch-list {
            display: grid;
            grid-template-columns: repeat(5, 23px);
            gap: 7px;
            width: 100%;
            align-items: center;
        }

        .product-card .swatch {
            max-width: 23px;
            width: 100%;
            aspect-ratio: 1 / 1;
            border-radius: 50%;
            border: 1px solid #e2e2e2;
            cursor: pointer;
            background-size: cover;
            background-position: center;
            box-sizing: border-box;
            height: auto;
        }
        .product-card  .swatch-container {
            margin: 0px;
        }

        .product-card.showen{
          display:flex!important;
        }

        .view-count{
          display: none;
        }
        .status-badge.is-live .view-count{
          display: flex;
        }
        </style>

      <div class="modal-overlay">
        <div class="modal-container">
          <button class="close-modal-btn" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>

          <div class="video-wrapper">
            <div id="video-status" class="status-badge">
              <span class="status-dot"></span>
              <span class="status-text">Recorded</span>
              <span class="view-count" style="
                                            padding: 2px 9px;
                                            border-radius: 3px;
                                            justify-content: center;
                                            align-items: center;
                                            gap: 5px;
                                            margin-left: 2px;
                                        ">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                            <circle cx="12" cy="12" r="3"></circle>
                                        </svg>
                                        <span id="viewer-count-text">10k</span></span>
            </div>
            <div class="countdown-overlay">
              <div class="countdown-text">Live stream starts in</div>
              <div id="countdown-timer">00:00:00</div>
            </div>
            <video id="main-video" playsinline muted preload="auto" src="${this._videoSrc}"></video>
            <div class="video-loader">
              <div class="spinner"></div>
            </div>         
            <div class="play-pause-overlay">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
            <div class="custom-controls">
              <svg width="18" height="18" fill="white" viewBox="0 0 24 24" style="margin-right:10px;"><path d="M8 5v14l11-7z"/></svg>
              <span id="time-display" style="font-family: monospace;">0:00 / 0:00</span>
              <div class="progress-container" id="progress-track">
                <div class="progress-bar" id="progress-fill"></div>
              </div>
              <button class="volume-btn" id="volume-toggle" style="background:none; border:none; color:white; cursor:pointer;">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.26 2.5-4.02z"/></svg>
              </button>
            </div>
          </div>

          <aside class="sidebar">
            <div class="sidebar-header">Timeline</div>
            <div id="product-list" show-active-only>
              ${this._state.products.map(p => `
                <h2 class="hide-mobile" style="display:none;">Next Up</h2>
                <div class="product-card" data-id="${p.id}" data-time="${p.timestamp}">
                  <img src="${p.image}" alt="${p.name}">
                  <div class="info">
                    <h4>${p.name}</h4>
                    <div><strong>${p.price}</strong></div>
                      ${ p.variants && p.variants.length > 0 ? `
                        <div class="swatch-container">
                          <div class="swatch-list">
                            ${p.variants.slice(0, 5).map(v => `
                              <div class="swatch ${v.id === p.id ? 'active' : ''}" 
                                  data-variant-id="${v.id}" 
                                  data-name="${v.name}"
                                  style="background-image: url('${v.thumb_img}'); background-position: bottom;">
                              </div>
                            `).join('')}
                          </div>
                        </div>
                      ` : ''}
                      <button style="
                                    width: fit-content;
                                    padding: 4px 10px 4px 10px;
                                    border-radius: 25px;
                                    border: none;
                                    background: var(--colorBtnPrimary);
                                    color: var(--colorBtnPrimaryText);
                                    margin-top: 5px;
                                ">Shop Now</button>
                  </div>
                  <div class="play-trigger">
                    <svg fill="currentColor" width="14" height="14" viewBox="0 0 32 32"><path d="M5.92 24.096q0 1.088 0.928 1.728 0.512 0.288 1.088 0.288 0.448 0 0.896-0.224l16.16-8.064q0.48-0.256 0.8-0.736t0.288-1.088-0.288-1.056-0.8-0.736l-16.16-8.064q-0.448-0.224-0.896-0.224-0.544 0-1.088 0.288-0.928 0.608-0.928 1.728v16.16z"/></svg>
                    <span class="link-time">${this.formatTime(p.timestamp)}</span>
                  </div>
                  <div class="selection-indicator-container"><div class="selection-indicator"></div></div>
                </div>
              `).join('')}
            </div>

            <div id="detail-view" class="detail-view">
              <div class="sticky-back-btn-container">
                <button class="back-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
                </button>
              </div>
              <div class="detail-scroll-area">
                <div id="detail-content">
                </div>
                <button class="buy-btn btn btn--full">
                  <span>ADD TO BAG</span>
                </button>
                <div id="detail-images" style="margin-top:20px;"></div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    `;

    this.initListeners();
    this.initCountdown();
    this.initViewerCounter();
  }
  
  initViewerCounter() {
    const countText = this.shadowRoot.getElementById('viewer-count-text');
    if (!countText) return;

    // We use this.startTime which you already normalized to UTC in connectedCallback
    const update = () => {
      const el = this.shadowRoot.getElementById('viewer-count-text');
      if (!el) return;

      // Date.now() is always UTC epoch. 
      // this.startTime was created with a timezone offset, so it is also UTC epoch.
      const elapsedMs = Date.now() - this.startTime;
      const elapsedSec = elapsedMs / 1000;

      // If the event hasn't started yet, keep it at the new floor (51)
      if (elapsedSec < 0) {
        el.textContent = "51";
        return;
      }

      let baseCount = 51; // Lower limit

      if (elapsedSec <= 60) {
        // 51 → 600 in the first minute
        baseCount = 51 + (elapsedSec / 60) * 549;
      } else if (elapsedSec <= 120) {
        // 600 → 1.1K in the second minute
        baseCount = 600 + ((elapsedSec - 60) / 60) * 500;
      } else {
        // REALISM AFTER 2 MINUTES:
        // Math.sin creates a smooth, continuous wave. 
        // It starts exactly at 1100, gradually surges up to ~1350, then drops down to ~850.
        // This guarantees you will see it drop below 1000 (showing exact numbers) and climb back up.
        baseCount = 1100 + Math.sin((elapsedSec - 120) / 30) * 250;
      }

      // Slightly increased jitter (+/- 3%) for realistic second-to-second micro-flickers
      const jitter = baseCount * (Math.random() * 0.06 - 0.03);
      let finalCount = Math.floor(baseCount + jitter);

      // Prevent it from ever randomly dipping below the very start point
      finalCount = Math.max(51, finalCount);

      // FORMATTING LOGIC: 
      // Show exact numbers before 1000, then switch to 'k' format
      if (finalCount < 1000) {
        el.textContent = finalCount.toString();
      } else {
        // When > 1000, this will now output 1.0k, 1.1k, 1.2k, 1.3k dynamically
        el.textContent = (finalCount / 1000).toFixed(1) + 'k';
      }
    };

    this._viewerInterval = setInterval(update, 6000);
    update(); 
  }
  initListeners() {
    const video = this.shadowRoot.getElementById('main-video');
    const timeDisplay = this.shadowRoot.getElementById('time-display');
    const progressTrack = this.shadowRoot.getElementById('progress-track');
    const progressFill = this.shadowRoot.getElementById('progress-fill');
    const volBtn = this.shadowRoot.getElementById('volume-toggle');
    const productList = this.shadowRoot.getElementById('product-list');
    const videoWrapper = this.shadowRoot.querySelector('.video-wrapper');
    const detailView = this.shadowRoot.getElementById('detail-view');

    detailView.addEventListener('click', (e) => {
      const swatch = e.target.closest('.swatch');
      if (!swatch) return;

      const variantId = swatch.dataset.variantId;
      
      // 1. Find the variant data
      let selectedVariant = null;
      for (const product of this._state.products) {
        if (product.id == variantId) {
          selectedVariant = product;
          break;
        }
        if (product.variants) {
          selectedVariant = product.variants.find(v => v.id == variantId);
          if (selectedVariant) break;
        }
      }

      // 2. Update state and re-render the detail view
      if (selectedVariant) {
        this.setState({ selectedProduct: selectedVariant });
        // Note: setState calls syncUI, which calls renderDetails automatically
      }
    });


    video.addEventListener('timeupdate', () => {
      const now = video.currentTime;
      const liveHead = (Date.now() - this.startTime) / 1000;
      const isLive = liveHead > 0 && liveHead < this.customDuration;

      let percentage = 0;
      let totalLabel = "";

      if (isLive) {
        // 1. SNAP TO 100%: If the video is within 2 seconds of the live head, 
        // we consider it "Caught up" and show 100%.
        if (Math.abs(liveHead - now) < 2) {
          percentage = 100;
        } else {
          // Otherwise, show how far back they are in the currently aired content
          percentage = (now / Math.max(liveHead, 1)) * 100;
        }
        totalLabel = "LIVE";
      } else {
        // 2. REPLAY MODE: If the event is over or hasn't started, 
        // use the full duration of the file.
        const duration = video.duration || this.customDuration;
        percentage = (now / Math.max(duration, 1)) * 100;
        totalLabel = this.formatTime(duration);
      }

      // Apply the width with a 100% cap for safety
      progressFill.style.width = `${Math.min(percentage, 100)}%`;
      timeDisplay.textContent = `${this.formatTime(now)} / ${totalLabel}`;

      let currentActiveId = null;
      const newRevealed = new Set();

      this._state.products.forEach((p, index) => {
        const nextP = this._state.products[index + 1];
        if (now >= p.timestamp) newRevealed.add(p.id);
        if (now >= p.timestamp && (!nextP || now < nextP.timestamp)) {
          currentActiveId = p.id;
        }
      });

      if (this._state.activeId !== currentActiveId) {
        this.setState({ revealedIds: newRevealed, activeId: currentActiveId });
        
        if (currentActiveId) {
          const activeCard = this.shadowRoot.querySelector(`[data-id="${currentActiveId}"]`);
          
          if (window.innerWidth > 900) {
            // Desktop vertical scroll
            activeCard?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } else {
            // Mobile horizontal scroll-snap
            activeCard?.scrollIntoView({ 
              behavior: 'smooth', 
              inline: 'center', 
              block: 'nearest' 
            });
          }
        }
      }
      this.updateStatusBadge();
    });


    videoWrapper.addEventListener('click', (e) => {
      // Prevent toggling if the user is clicking the progress bar or volume button
      if (e.target.closest('.custom-controls')) return;

      if (video.paused) {
        video.play().catch(err => console.error("Playback failed:", err));
      } else {
        video.pause();
      }
    });
    video.addEventListener('play', () => {
      const playIcon = this.shadowRoot.querySelector('.custom-controls svg:first-child');
      // Update to Pause Icon (Two vertical bars)
      playIcon.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>';
      videoWrapper.classList.remove('is-paused');
    });

    video.addEventListener('pause', () => {
      const playIcon = this.shadowRoot.querySelector('.custom-controls svg:first-child');
      // Update to Play Icon (Triangle)
      playIcon.innerHTML = '<path d="M8 5v14l11-7z"/>';
      videoWrapper.classList.add('is-paused');
    });
    video.addEventListener('waiting', () => {
      videoWrapper.classList.add('is-loading');
    });
    video.addEventListener('playing', () => {
      videoWrapper.classList.remove('is-loading');
    });
    video.addEventListener('canplay', () => {
      videoWrapper.classList.remove('is-loading');
    });
    progressTrack.addEventListener('click', (e) => {
      const rect = progressTrack.getBoundingClientRect();
      const clickedTime = ((e.clientX - rect.left) / rect.width) * video.duration;

      // 1. Calculate how many seconds have passed since the start
      const now = Date.now();
      const elapsedSeconds = (now - this.startTime) / 1000;

      // 2. Check if we are currently within the live window
      // (Started, but not yet finished)
      if (elapsedSeconds > 0 && elapsedSeconds < this.customDuration) {
        
        // CAP: If the user clicked ahead of 'elapsedSeconds', 
        // it will snap to the current live point.
        video.currentTime = Math.min(clickedTime, elapsedSeconds);
        
      } else if (elapsedSeconds >= this.customDuration) {
        // REPLAY MODE: If the video is finished, allow full seeking
        video.currentTime = clickedTime;
      } else {
        // NOT STARTED: If someone manages to click before it starts, force 0
        video.currentTime = 0;
      }
    });

    volBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      volBtn.style.opacity = video.muted ? '0.4' : '1';
    });

    productList.addEventListener('click', (e) => {
      const trigger = e.target.closest('.play-trigger');
      const card = e.target.closest('.product-card');

      if (trigger) {
        video.currentTime = parseFloat(card.dataset.time);
        video.play();
      } else if (card) {
        const product = this._state.products.find(p => p.id == card.dataset.id);
        this.setState({ selectedProduct: product, isDetailViewOpen: true });
      }
    });

    this.shadowRoot.querySelector('.back-btn').addEventListener('click', () => {
      this.setState({ isDetailViewOpen: false });
    });

    this.shadowRoot.querySelector('.close-modal-btn').addEventListener('click', () => this.close());

    this.shadowRoot.querySelector('.buy-btn').addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const product = this._state.selectedProduct;
      console.log(product)

      // 1. Add loading class
      btn.classList.add('btn--loading');
      btn.disabled = true; // Optional: prevent double-clicks
      const bundleId = 'LS_' + Date.now().toString();

      try {
        // 2. Wait for the addToCart logic to finish
        await this.addToCart(product, bundleId);
      } finally {
        // 3. Remove loading class regardless of success/error
        btn.classList.remove('btn--loading');
        btn.disabled = false;        
        this.fetchStrapData(product.handle, bundleId);
        // var cart = new theme.CartDrawer;
        // cart.init();
        // cart.open(); 
      }
    });
  }

  renderDetails() {
    
    
    const p = this._state.selectedProduct;
    console.log(p)
    if (!p) return;

    const parentProduct = this._state.products.find(item => 
      item.id === p.id || (item.variants && item.variants.some(v => v.id === p.id))
    );

    const variants = parentProduct?.variants || [];

    this.shadowRoot.getElementById('detail-content').innerHTML = `
      <img src="${p.image}">
      <h2 style="margin:0 0 10px 0; line-height: 1;">${p.name}</h2>
      <p style="line-height:1.6; color: #666; font-size: 14px;">${p.description || 'Premium craftsmanship and timeless design.'}</p>
      <div style="font-size: 1.5rem; font-weight: bold; margin: 20px 0;">${p.price}</div>
        ${variants.length > 0 ? `
          <div class="swatch-container">
            <span class="swatch-label">Colour:</span>
            <div class="swatch-list">
              ${variants.map(v => `
                <div class="swatch ${v.id === p.id ? 'active' : ''}" 
                    data-variant-id="${v.id}" 
                    data-name="${v.name}"
                    style="background-image: url('${v.thumb_img}'); background-position: bottom;">
                </div>
              `).join('')}
            </div>
          </div>
        ` : ''}
    `;

    this.shadowRoot.getElementById('detail-images').innerHTML = `
       <ul style="display:flex; flex-direction:column; gap:10px; padding:0; list-style:none; margin:0;">
        ${(p.gallery || []).map(img => `
          <li>
            <img src="${img}" style="width:100%; height:auto; object-fit:cover; cursor:pointer;">
          </li>
        `).join('')}
      </ul>
    `;
  }

  /**
   * Fetches strap data for a specific product handle and populates all_free_straps
   * @param {string} handle - The Shopify product handle
   */
  async fetchStrapData(handle, bundleId) {
    try {
      const response = await fetch(`/products/${handle}?sections=product-customization-straps-list`);
      const data = await response.json();
      const sectionHtml = data['product-customization-straps-list'];
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const jsonScript = doc.getElementById('strap-upsell-data');

      if (jsonScript) {
        const rawData = JSON.parse(jsonScript.textContent);
        
        // Check if there are ANY upsell items available
        if ((rawData.all_straps && rawData.all_straps.length > 0) || (rawData.all_purses && rawData.all_purses.length > 0)) {          
          this.showTwoStepModal(rawData, bundleId);
        } else {          
          this.openCartDrawer();
        }
      } else {
        this.openCartDrawer();
        console.error("Could not find strap JSON in the returned section.");
      }
    } catch (error) {
      this.openCartDrawer();
      console.error("Error fetching strap data:", error);
    }
  }

  showTwoStepModal(upsellData, bundleId) {
    // Reset state
    this._upsellState = {
      data: upsellData,
      bundleId: bundleId,
      selectedStraps: [],
      selectedPurse: null,
      step: 1
    };

    // Remove old if exists
    if (document.querySelector('.live-upsell-modal')) {
      document.querySelector('.live-upsell-modal').remove();
    }

    const modal = document.createElement('div');
    modal.className = 'live-upsell-modal';
    modal.innerHTML = `
      <style>
        .live-upsell-modal { position: fixed; inset: 0; z-index: 999999; display: flex; align-items: center; justify-content: center; font-family: inherit; }
        .live-upsell-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.6); backdrop-filter: blur(5px); }
        .live-upsell-content { position: relative; background: #fff; width: 95%; max-width: 650px; height: 85vh; max-height: 800px; display: flex; flex-direction: column; border-radius: 12px; overflow: hidden; box-shadow: 0 10px 40px rgba(0,0,0,0.2); }
        .live-upsell-header { padding: 25px 20px; text-align: center; border-bottom: 1px solid #eee; font-weight: bold; font-size: 1.1rem; margin: 0; letter-spacing: 1px; }
        .live-upsell-grid { padding: 20px; overflow-y: auto; flex-grow: 1; display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 15px; }
        .live-upsell-item { border: 2px solid transparent; padding: 10px; text-align: center; cursor: pointer; border-radius: 8px; transition: all 0.2s; }
        .live-upsell-item.is-selected { border-color: #0c314a; background: #fafafa; }
        .live-upsell-item img { width: 100%; height: auto; display: block; margin-bottom: 12px; border-radius: 4px; }
        .live-upsell-item-title { font-size: 13px; margin-bottom: 12px; display: block; line-height: 1.3; font-weight: 500;     min-height: 34px;}
        .live-upsell-btn { background: #fff; color: #0c314a; border: 1px solid #ddd; width: 100%; padding: 10px; cursor: pointer; font-size: 12px; font-weight: bold; border-radius: 4px; transition: all 0.2s; }
        .live-upsell-item.is-selected .live-upsell-btn { background: #0c314a; color: #fff; border-color: #0c314a; }
        .live-upsell-footer { padding: 20px; border-top: 1px solid #eee; text-align: center; background: #fff; }
        .live-upsell-action-btn { background: #0c314a; color: #fff; border: none; padding: 16px 24px; font-size: 14px; font-weight: bold; cursor: pointer; width: 100%; max-width: 400px; border-radius: 4px; letter-spacing: 1px; transition: opacity 0.2s; }
        .live-upsell-action-btn:disabled { opacity: 0.4; cursor: not-allowed; }
        .live-upsell-close { position: absolute; top: 15px; right: 20px; background: none; border: none; font-size: 28px; cursor: pointer; line-height: 1; color: #333; }
      </style>
      <div class="live-upsell-overlay"></div>
      <div class="live-upsell-content">
        <button class="live-upsell-close">&times;</button>
        <h2 class="live-upsell-header" id="live-upsell-title">LOADING...</h2>
        <div class="live-upsell-grid" id="live-upsell-grid"></div>
        <div class="live-upsell-footer">
          <button id="live-upsell-action" class="live-upsell-action-btn" disabled>NEXT STEP</button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector('.live-upsell-close').addEventListener('click', () => modal.remove());
    modal.querySelector('.live-upsell-overlay').addEventListener('click', () => modal.remove());

    this.renderUpsellStep();
  }

  renderUpsellStep() {
    const title = document.getElementById('live-upsell-title');
    const grid = document.getElementById('live-upsell-grid');
    const actionBtn = document.getElementById('live-upsell-action');
    const state = this._upsellState;

    if (!grid || !state.data) return;

    if (state.step === 1) {
      title.textContent = `STEP 1: SELECT 2 FREE STRAPS (${state.selectedStraps.length}/2)`;
      const straps = state.data.all_straps || [];
      
      grid.innerHTML = straps.map(item => {
        const isSelected = state.selectedStraps.includes(item.id.toString());
        return `
          <div class="live-upsell-item ${isSelected ? 'is-selected' : ''}" data-id="${item.id}" data-type="strap">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
            <span class="live-upsell-item-title">${item.title}</span>
            <button class="live-upsell-btn">${isSelected ? 'SELECTED' : 'SELECT'}</button>
          </div>
        `;
      }).join('');

      actionBtn.textContent = 'NEXT STEP';
      actionBtn.disabled = state.selectedStraps.length !== 2;
      actionBtn.onclick = () => {
        state.step = 2;
        this.renderUpsellStep();
        grid.scrollTo(0, 0); // scroll to top for step 2
      };

    } else if (state.step === 2) {
      title.textContent = `STEP 2: SELECT 1 FREE PURSE (${state.selectedPurse ? 1 : 0}/1)`;
      const purses = state.data.all_purses || [];

      grid.innerHTML = purses.map(item => {
        const isSelected = state.selectedPurse === item.id.toString();
        return `
          <div class="live-upsell-item ${isSelected ? 'is-selected' : ''}" data-id="${item.id}" data-type="purse">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
            <span class="live-upsell-item-title">${item.title}</span>
            <button class="live-upsell-btn">${isSelected ? 'SELECTED' : 'SELECT'}</button>
          </div>
        `;
      }).join('');

      actionBtn.textContent = 'CONFIRM & ADD TO CART';
      actionBtn.disabled = !state.selectedPurse;
      actionBtn.onclick = (e) => this.submitUpsellSelections(e.currentTarget);
    }

    // Attach click listeners for items
    grid.querySelectorAll('.live-upsell-item').forEach(el => {
      el.addEventListener('click', (e) => {
        const id = e.currentTarget.getAttribute('data-id');
        const type = e.currentTarget.getAttribute('data-type');
        
        if (type === 'strap') {
          if (state.selectedStraps.includes(id)) {
            state.selectedStraps = state.selectedStraps.filter(s => s !== id);
          } else if (state.selectedStraps.length < 2) {
            state.selectedStraps.push(id);
          } else {
            alert('You can only select a maximum of 2 straps.');
          }
        } else if (type === 'purse') {
          state.selectedPurse = state.selectedPurse === id ? null : id;
        }
        
        this.renderUpsellStep();
      });
    });
  }

  async submitUpsellSelections(actionBtn) {
    actionBtn.textContent = 'PROCESSING...';
    actionBtn.disabled = true;

    const state = this._upsellState;
    const itemsToAdd = [];

    state.selectedStraps.forEach(id => {
      itemsToAdd.push({ id: parseInt(id), quantity: 1, properties: { '_bundle_id': state.bundleId } });
    });

    if (state.selectedPurse) {
      itemsToAdd.push({ id: parseInt(state.selectedPurse), quantity: 1, properties: { '_bundle_id': state.bundleId } });
    }

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });

      // Remove the 2-step modal
      document.querySelector('.live-upsell-modal')?.remove();

      // Trigger Cart Drawer Updates
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      
      if (typeof theme !== 'undefined' && theme.CartDrawer) {
        var cart = new theme.CartDrawer();
        cart.init(); 
        setTimeout(() => cart.open(), 400); 
      } else {
        window.location.reload();
      }

    } catch (err) {
      console.error('Failed to add upsell items:', err);
      alert('There was an error adding your free items. Please try again.');
      actionBtn.textContent = 'CONFIRM & ADD TO CART';
      actionBtn.disabled = false;
    }
  }

  openCartDrawer(){    
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }
}

customElements.define('shoppable-modal', ShoppableModal);





document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn.btn--inverse');
    if (!btn) return;

    const text = btn.textContent.replace(/\s+/g, ' ').trim();

    if (text.includes('Join The Live Experience')) {
      e.preventDefault(); // stop link navigation
      document.querySelector('#shopable-video-button')?.click();
    }
  });
});